import React from 'react';
import { Target, TrendingUp, Award, Users } from 'lucide-react';
import { companyInfo } from '../data/mock';

const AboutSection = () => {
  const highlights = [
    {
      icon: Target,
      title: "Visão Estratégica",
      description: "Planejamento focado em resultados reais"
    },
    {
      icon: TrendingUp,
      title: "Crescimento Sustentável",
      description: "Desenvolvimento estruturado do seu negócio"
    },
    {
      icon: Award,
      title: "Posicionamento de Marca",
      description: "Destaque sua empresa no mercado"
    },
    {
      icon: Users,
      title: "Atendimento Personalizado",
      description: "Seu negócio tratado como nosso"
    }
  ];

  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-6">
            Quem é a <span className="text-gold-600">DumanginADM</span>
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto" />
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              {companyInfo.description}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              No marketing, nosso foco é <strong className="text-navy-900">branding</strong>, garantindo que a marca tenha identidade, coerência e autoridade no mercado. Também desenvolvemos e aplicamos ferramentas de <strong className="text-navy-900">SEO, inbound marketing, gestão de conteúdo</strong> e estratégias digitais voltadas para atração, relacionamento e conversão de clientes.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {companyInfo.fullDescription}
            </p>

            <div className="pt-6">
              <blockquote className="border-l-4 border-gold-500 pl-6 py-2">
                <p className="text-xl font-medium text-navy-900 italic">
                  "Administração inteligente, marketing estratégico e marcas que se destacam."
                </p>
              </blockquote>
            </div>
          </div>

          {/* Highlights Grid */}
          <div className="grid grid-cols-2 gap-6">
            {highlights.map((item, index) => (
              <div 
                key={index}
                className="group bg-gray-50 hover:bg-navy-900 p-6 rounded-2xl transition-all duration-500 hover:shadow-xl"
              >
                <div className="w-14 h-14 bg-gold-500/10 group-hover:bg-gold-500 rounded-xl flex items-center justify-center mb-4 transition-all duration-500">
                  <item.icon className="w-7 h-7 text-gold-600 group-hover:text-navy-900 transition-colors duration-500" />
                </div>
                <h3 className="text-lg font-semibold text-navy-900 group-hover:text-white mb-2 transition-colors duration-500">
                  {item.title}
                </h3>
                <p className="text-gray-600 group-hover:text-white/70 text-sm transition-colors duration-500">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
